import { render, staticRenderFns } from "./CookieConsentNewDesign.vue?vue&type=template&id=7123e4f2&scoped=true"
import script from "./CookieConsentNewDesign.vue?vue&type=script&lang=js"
export * from "./CookieConsentNewDesign.vue?vue&type=script&lang=js"
import style0 from "./CookieConsentNewDesign.vue?vue&type=style&index=0&id=7123e4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7123e4f2",
  null
  
)

export default component.exports